import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@iso/lib//helpers/api';
import { types, actions } from './reducer';
import CategoryService from '@iso/services/SettingsService/ProductService/CategoryService';

function* deleteCategory({ id }) {
    try {
        yield call(CategoryService.deleteOne, id);
        yield put(actions.deleteCategorySucceeded(id));
    } catch (error) {
        yield put(actions.deleteCategoryFailed(extractError(error)));
    }
}

function* watchDeleteCategory() {
    yield takeEvery(
        types.REQUEST_DELETE_CATEGORY,
        deleteCategory,
    );
}

function* deleteSaga() {
    yield all([
        fork(watchDeleteCategory),
    ]);
}

export default deleteSaga;
